import { useProduct } from '@modules/product';

/**
 * Return base url asset paths for product and swatch images
  * @returns {{
  * swatchUrlTemplate: string,
  * productUrlTemplate: string
  * }}
 */
export default function useUrlTemplate() {
  const { productData } = useProduct();

  if (productData) {
    return {
      swatchUrlTemplate: productData?.urlTemplate?.swatch || '',
      productUrlTemplate: productData?.urlTemplate?.product || '',
    };
  }

  return {
    swatchUrlTemplate: '',
    productUrlTemplate: '',
  };
}
